import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['school', 'county'];

  updateDropdown(data, target) {
    data.forEach((school) => {
      const option = document.createElement('option');
      option.value = school.id;
      option.innerHTML = school.name;
      target.appendChild(option);
    });
  }

  selectCounty() {
    const element = this.countyTarget;
    const countyIds = Array.from(element.selectedOptions).map((option) => option.value);

    $.ajax({
      type: 'get',
      url: element.dataset.way + '.json',
      data: new URLSearchParams({ county_id: countyIds }).toString(),
      success: (data) => {
        this.updateDropdown(data, this.schoolTarget);
      },
    });
  }
}
